
import { i18n } from '@/plugins/i18n'
import { apollo } from '@/plugins/apollo'
// graphql files
import list from 'GraphQL/queries/purchaseOrders/list.gql'
import details from 'GraphQL/queries/purchaseOrders/details.gql'

export default {
  async getList ({ rootState, commit }, payload = false) {
    if (payload) {
      await commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: list,
      variables: {
        apiToken: rootState.session.apiToken,
        startDate: payload?.startDate || null,
        endDate: payload?.endDate || null
      }
    }).then(response => {
      const { status, result } = response.data.purchaseOrders

      switch (status) {
        case 'OK':
          if (payload?.startDate && payload?.endDate && payload?.method) {
            commit('toggle', { method: payload?.method ?? 'list', status, result: result })
          } else {
            commit('setList', result)
          }
          break
        case 'ACCESSDENIED':
          commit('toggleSnackbar', { message: i18n.t('errors.accessDenied'), color: 'red darken-2' }, { root: true })
          break
        case 'BADREQUEST':
          commit('toggleSnackbar', { message: i18n.t('errors.invalidFields'), color: 'orange darken-2' }, { root: true })
          break
        case 'UNPROCESSABLE':
          commit('toggleSnackbar', { message: i18n.t('errors.invalidFields'), color: 'orange darken-2' }, { root: true })
          break
        case 'INTERNALERROR':
          commit('toggleSnackbar', { message: i18n.t('helpers.errors.disaster'), color: 'red darken-2' }, { root: true })
          break
      }
    }).catch(err => {
      if (payload) {
        console.error(err)
        commit('toggleSnackbar', { message: i18n.t('helpers.errors.disaster'), color: 'red darken-2' }, { root: true })
      }
    }).finally(() => {
      commit('setLoading', false, { root: true })
    })
  },

  async updateList ({ rootState, commit }, payload = false) {
    if (payload) {
      await commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: list,
      variables: {
        apiToken: rootState.session.apiToken
      }
    }).then(response => {
      const { status, result } = response.data.purchaseOrders

      switch (status) {
        case 'OK':
          commit('updateList', { rootState: rootState, payload: result, commit: commit })
          break
        case 'ACCESSDENIED':
          commit('toggleSnackbar', { message: i18n.t('errors.accessDenied'), color: 'red darken-2' }, { root: true })
          break
        case 'BADREQUEST':
          commit('toggleSnackbar', { message: i18n.t('errors.invalidFields'), color: 'orange darken-2' }, { root: true })
          break
        case 'UNPROCESSABLE':
          commit('toggleSnackbar', { message: i18n.t('errors.invalidFields'), color: 'orange darken-2' }, { root: true })
          break
        case 'INTERNALERROR':
          commit('toggleSnackbar', { message: i18n.t('helpers.errors.disaster'), color: 'red darken-2' }, { root: true })
          break
      }
    }).catch(err => {
      commit('cleanInterval', err)
    }).finally(() => {
    })
  },

  async details ({ rootState, commit }, id) {
    await commit('setLoading', true, { root: true })
    await apollo.query({
      query: details,
      variables: {
        apiToken: rootState.session.apiToken,
        id
      }
    }).then(response => {
      const { status, result } = response.data.purchaseOrders
      switch (status) {
        case 'OK':
          if (result.length === 1) {
            commit('toggle', { method: 'details', status, result: result[0] })
          } else {
            commit('toggleSnackbar', { message: i18n.t('errors.itemNotFound'), color: 'red darken-2' }, { root: true })
            commit('toggle', { method: 'details', status: 'NOTFOUND', result: null })
          }
          break
        case 'ACCESSDENIED':
          commit('toggleSnackbar', { message: i18n.t('errors.accessDenied'), color: 'red darken-2' }, { root: true })
          commit('toggle', { method: 'details', status, result: null })
          break
        case 'BADREQUEST':
          commit('toggleSnackbar', { message: i18n.t('errors.invalidFields'), color: 'orange darken-2' }, { root: true })
          commit('toggle', { method: 'details', status, result: null })
          break
        case 'UNPROCESSABLE':
          commit('toggleSnackbar', { message: i18n.t('errors.invalidFields'), color: 'orange darken-2' }, { root: true })
          commit('toggle', { method: 'details', status, result: null })
          break
        case 'INTERNALERROR':
          commit('toggleSnackbar', { message: i18n.t('helpers.errors.disaster'), color: 'red darken-2' }, { root: true })
          commit('toggle', { method: 'details', status, result: null })
          break
      }
    }).catch(err => {
      console.error(err)
      commit('toggleSnackbar', { message: i18n.t('helpers.errors.disaster'), color: 'red darken-2' }, { root: true })
      commit('toggle', { method: 'details', status: 'INTERNALERROR', result: null })
    }).finally(() => {
      commit('setLoading', false, { root: true })
    })
  }
}
